import {Typography, useSupportWidgetShow} from '@logistics-frontend/blocks'
import React, {useMemo} from 'react'

import supportSrc from 'src/shared/assets/Headphones.svg'
import {config} from 'src/shared/config'

import {classes} from './SupportButton.classes'
import {mapToSupportContext} from './SupportButton.utils'
import {SupportAction} from './types'

type Props = {
  action: SupportAction
}

const SupportButton: React.FC<Props> = ({action}) => {
  const supportParams = useMemo(
    () => ({
      guid: config.supportBotID,
      context: mapToSupportContext(action),
    }),
    [action],
  )

  const showSupportHandler = useSupportWidgetShow(supportParams)

  return (
    <div className={classes.actionWrapper}>
      <button
        className={classes.action}
        onClick={showSupportHandler}
        style={{backgroundImage: `url("${supportSrc}")`}}
      />
      <Typography color="minor" justifyContent="center" variant="caption1">
        {action.title}
      </Typography>
    </div>
  )
}

export default SupportButton
